import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import {} from "../../../shared";

@Component({
    selector: "app-header-notify",
    templateUrl: "./header-notify.component.html",
    styleUrls: ["./header-notify.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderNotifyComponent implements OnInit {
  visible = false;
  loading = true;
  noticeList = [];
  orderList = [];
  constructor(private msg: NzMessageService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {}
}
